module.exports = __webpack_public_path__ + "img/word.40cdeedb.svg";